var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.ulListCheck),function(item,i){return _c('div',{key:i,staticClass:"flex items-center"},[_c('img',{staticClass:"mr-2",attrs:{"src":_vm.checkIcon,"alt":"check","width":"20"}}),_vm._v(" "+_vm._s(item.li)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }